/* eslint-disable jsx-a11y/img-redundant-alt */
import { t } from "../../../i18n";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { ContentModelName } from "../../../contenful/types";
import { showCashier } from "../../../payments/DepositActions";
import { CashierSection } from "../../../payments/PaymentsReducer";
import { fetchAndParseContent } from "../../../contenful/ContentfulActions";
import { ModalProps, PATH  } from "../UserModalController";
import { Modal } from "react-bootstrap";
import ModalCloseBtn from "../ui/ModalCloseBtn";
import { getContainer } from "../../../ioc/IOCSetup";
import { Spinner } from "../../../ui/Spinner";
import { isHomeScreen, setModalPath, useClickOutside } from "../utils";

const RegisterSuccessModal = ({ ...rest }: Partial<ModalProps>) => {
  
  const { history, user, content, location } = rest;
  const homeScreen = isHomeScreen();

  const dispatch = useDispatch();
  const [startPlaying, setStartPlaying] = useState<boolean>(false);
  const showDepositModal = () => dispatch(showCashier(true, CashierSection.DEPOSIT));
  
  const ref = useRef(null);
  useClickOutside(ref, () => setModalPath({ path: undefined, history }));

  // Defualt language is set in contentful
  const [ language ] = useState(()=> {
    try {
      return getContainer().getSettingsService().getActiveLocale().code;
    } catch (_) {
      return undefined
    }
  })

  // Get contentful content
  useEffect(() => {
    if (content && content.onboardingpage === undefined) {
      dispatch(fetchAndParseContent(ContentModelName.ONBOARDINGPAGE, language) as any);
    }
    if (content && content.global === undefined) {
      dispatch(fetchAndParseContent(ContentModelName.GLOBAL, language) as any);
    }
  }, []);

  // Redirect to games, OBS? => Redirect function
  useEffect(() => {
      if (history && startPlaying) {
        if (["casino", "poker", "sports", "racing"].some(str => location?.pathname.includes(str))) {
          setModalPath({ path: undefined, history });
        } else {
          history.push("/casino")
        }
      }
  }, [user, startPlaying]);


  
  if (content && content?.isFetching){
    return <div id="sc" data-testid={PATH.REGISTER_SUCCESS}><Spinner/></div>
  }  

  const imgUrl = content && content.onboardingpage?.registerSuccessLogo?.fields?.file?.url;
  
  return (
    <div className={`modal-wrapper ${PATH.REGISTER_SUCCESS} ${!homeScreen ? "active" : null}`} ref={!homeScreen ? ref : null}>
      {!homeScreen && <ModalCloseBtn onClick={()=>setModalPath({path: undefined, history})}/>}
      <div className="modal-container">
        <Modal.Header>
          {imgUrl && <img src={imgUrl} alt={"Success-image"} />}
        </Modal.Header>
        <Modal.Body>
          <h4>{t("user.registration-success-title")}</h4>
          <p className="info">{t("user.registration-success-info")}</p>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={() => setStartPlaying(true)} className="btn btn-cta full-width small">
            {t("global.startPlaying")}
          </button>
          <span onClick={() => showDepositModal()} className="deposit">
            {t("global.depositButton")}
          </span>
        </Modal.Footer>
      </div>
    </div>
  );
};

export default RegisterSuccessModal;























